import { staticColors } from '@/features/shared/theme/staticColors'
import { themeTokens } from '@/features/shared/theme/tokens'
import { marketplaceLight } from '@shipt/design-system-themes'

export const theme = {
  ...staticColors,
  headerBanner: '#502D91',
  primary: '#241239',
  primaryOnLight: '#241239',
  primaryContrast: '#FFFFFF',
  ...marketplaceLight,
  ...themeTokens,
}

export type ShiptTheme = typeof theme
